import type { User } from '@/types/auth';
import { hasPermission, Permission } from './permissions';

export const hasExceptionalAppealAccess = (
  user: User | null | undefined,
): boolean => hasPermission(user, Permission.APPEALS_READ);

export const hasExceptionalAppealSuccessAccess = (
  user: User | null | undefined,
): boolean => hasPermission(user, Permission.APPEALS_RESOLVE_SUCCESS);
